import { render, staticRenderFns } from "./CoProgressBar.vue?vue&type=template&id=6b231732&scoped=true&"
import script from "./CoProgressBar.vue?vue&type=script&lang=ts&"
export * from "./CoProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./CoProgressBar.vue?vue&type=style&index=0&id=6b231732&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b231732",
  null
  
)

export default component.exports